import { GuardianRelationship } from "../types/guardianTypes";
import { TFunction } from "i18next";

export const GUARDIAN_RELATIONSHIP_OPTIONS = (
  t?: TFunction
): { label: string; value: GuardianRelationship }[] => [
  { label: t ? t("father") : "Father", value: "father" },
  { label: t ? t("mother") : "Mother", value: "mother" },
  { label: t ? t("guardian") : "Guardian", value: "guardian" },
];


export const GUARDIAN_FAMILY_SITUATION_OPTIONS = (
  t?: TFunction
): { label: string; value: string }[] => [
  { label: t ? t("guardianModule.situation.SINGLE") : "Single", value: "SINGLE" },
  { label: t ? t("guardianModule.situation.MARRIED") : "Married", value: "MARRIED" },
  { label: t ? t("guardianModule.situation.DIVORCED") : "Divorced", value: "DIVORCED" },
  { label: t ? t("guardianModule.situation.WIDOWED") : "Widowed", value: "WIDOWED" },
  // { label: t ? t("guardianModule.situation.SEPARATED") : "Separated", value: "SEPARATED" },
  // { label: t ? t("guardianModule.situation.COHABITING") : "Cohabiting", value: "COHABITING" },
  { label: t ? t("guardianModule.situation.OTHER") : "Other", value: "OTHER" },
];